<!--  -->
<template>
  <div>
    <div class="tinymce_box">
      <div>
        <div class="tabselecr_box">
          <div class="search_box">
            <el-input v-model="obj.keywords" clearable style="width:400px;" placeholder="请输入编号/标题" />
            <el-select v-model="obj.onlyMe" placeholder="请选择" style="margin-left:20px">
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <!--  <el-select v-model="obj.push_method" placeholder="请选择" style="margin-left:20px">
              <el-option
                v-for="item in accountarrsa"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select> -->
            <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
            <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
            <el-button type="danger" @click="getSelectedRows">批量删除</el-button>
            <!-- <el-button type="success" icon="el-icon-plus" @click="addlink(1)">新增网页跳转</el-button> -->
          </div>
        </div>

        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData.list"
          border
          tooltip-effect="dark"
          style="width: 100%;margin-top:20px"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column
            prop="sp_moments_no"
            label="编号"
            align="center"
            width="300px"
          />
          <el-table-column
            prop="send_type_text"
            label="发送方式"
            align="center"
            width="100px"
          />
          <el-table-column
            prop="title"
            label="标题"
            align="center"
            width="230"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="标题"
                width="200"
                trigger="hover"
                :content="scope.row.title"
              >
                <div slot="reference" class="content_box">{{ scope.row.title }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="content"
            label="消息文本"
            align="center"
            width="230"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="消息文本"
                width="200"
                trigger="hover"
                :content="scope.row.content"
              >
                <div slot="reference" class="content_box">{{ scope.row.content }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="comment"
            label="评论"
            align="center"
            width="230"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="评论"
                width="200"
                trigger="hover"
                :content="scope.row.comment"
              >
                <div slot="reference" class="content_box">{{ scope.row.comment }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            align="center"
            width="200"
          />
          <!-- <el-table-column
            prop="push_method_text"
            label="发送方式"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.push_method_text }}</div>
            </template>
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="realName"
            width="100"
            label="创建人"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <!-- <el-button type="warning" size="mini" @click="prwiedit(scope.row)">预览</el-button>
              <el-button type="primary" size="mini" @click="editr(2,scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" @click="editr(3,scope.row)">复用</el-button>
              <el-button type="danger" size="mini" @click="deteleter(scope.row.sp_message_no)">删除</el-button> -->
              <el-button type="warning" size="mini" @click="prwiedit(scope.row)">预览</el-button>
              <el-button type="primary" size="mini" @click="editr(2,scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" @click="editr(3,scope.row)">复用</el-button>
              <el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
              <!--
              <el-button type="danger" size="mini" @click="deteleter(scope.row.sp_message_no)">删除</el-button> -->
            </template>
          </el-table-column>

        </el-table>
        <pagination-right
          :current-page="obj.page"
          :total="tableData.total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>

      <!-- <el-dialog title="新增" width="40%" :visible.sync="dialogTableVisible" append-to-body :close-on-click-modal="false" :destroy-on-close="true">
        <Customerservice ref="sur" @updata="updata" />
      </el-dialog> -->

      <!-- 预览标签组弹窗 -->
      <el-dialog
        title="预览"
        :visible.sync="priwdialogVisible"
        :modal-append-to-body="false"
        :append-to-body="true"
        width="25%"
      >
        <previewdialog ref="timepreview" />
      </el-dialog>
    </div>

  </div>
</template>

<script>
// import { customerMessagedelete, templateAdmindelete } from '@/api/sourceMaterial.js'
import { spdeleteMessage } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import Customerservice from './components/Customerservice.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { momentsDel, momentsList } from '@/api/workWechat.js'
import previewdialog from './components/previewdialog.vue'
export default {
  name: 'Enterpmessagelist',
  components: { PaginationRight, previewdialog },
  // components: { PaginationRight, previewdialog },
  mixins: [convertToHump],
  data() {
    return {
      tableData: [],
      obj: {
        page: 1,
        page_size: 10,
        keywords: null,
        onlyMe: 2
        // push_method: ''
      },
      dialogTableVisible: false,
      priwdialogVisible: false,
      type: '1',
      options: [],
      loading: false,
      templatedata: [],
      templatetotalre: null,
      plateoption: [],
      palateid: null,
      accountarr: [{
        value: 1,
        label: '查看组内客服消息'
      }, {
        value: 2,
        label: '我关联的客服消息'
      }],
      accountarrsa: [
        {
          value: '',
          label: '全部发送方式'
        }, {
          value: 1,
          label: '官方接口'
        }, {
          value: 2,
          label: '第三方接口'
        }]
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  activated() {
    this.menuList()
  },
  methods: {
    menuList() {
      this.loading = true
      momentsList(this.obj).then(res => {
        console.log('res', res)
        this.tableData = res.data
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.obj.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.menuList()
    },
    add(type) {
      // this.type = type
      // this.dialogTableVisible = true
      // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //   this.$refs.sur.opens(type)
      // }, 100)
      this.$router.push({
        query: {
          type: 1
        },
        path: '/addMessage/index'
      })
    },
    getSelectedRows() {
      const selectedRows = this.$refs.multipleTable.selection
      console.log(selectedRows)
      if (selectedRows.length === 0) {
        return this.$message.error('选项为空,请选择')
      }
      if (selectedRows) {
        this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(selectedRows)
          this.delMoment(selectedRows.map(item => item.sp_moments_no))
        })
      }
    },
    editr(type, item) {
      this.type = type
      // this.dialogTableVisible = true
      // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //   this.$refs.sur.opens(type, item)
      // }, 100)
      console.log('bianji', item)
      this.$router.push({
        query: {
          type: type,
          sp_moments_no: item.sp_moments_no,
          id: item.id
        },
        path: '/addMessage/index'
      })
    },
    del(val) {
      this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(val)
        this.delMoment([val.sp_moments_no])
      })
    },
    delMoment(val) {
      momentsDel({ sp_moments_nos: val }).then(res => {
        console.log(res, 222)
        if (res.code === 400) {
          this.$message.error(res.data.message)
        }
        if (res.code === 200) {
          this.$message.success('请求成功')
          this.menuList()
        }
      })
    },
    addlink(type) {
      this.$router.push({
        path: '',
        query: {
          type: type
        }
      })
    },
    rechargeclick() {
      this.obj.page = 1
      this.obj.keywords = null
      // this.obj.push_method = ''
      this.menuList()
    },
    searchclick() {
      this.obj.page = 1
      this.menuList()
    },
    prwiedit(item) {
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item)
      }, 100)
    },
    deteleter(id) {
      this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        spdeleteMessage({
          sp_message_no: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.menuList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
      // customerMessagedelete
    },
    // detelterw(id) {
    //   this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     templateAdmindelete({
    //       messageNo: id
    //     }).then((res) => {
    //       this.$message({
    //         type: 'success',
    //         message: '删除成功!'
    //       })
    //       this.gettemplateadminlist()
    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     })
    //   })
    // },
    updata() {
      this.dialogTableVisible = false
      this.menuList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tinymce_box{
  /* width: 1200px;
  margin: 0 auto;
  margin-top: 50px; */
  padding: 30px;
}
.tinymceserve_box{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox{
  width: 200px;
  margin-left: 20px;
}
.functional_area{
  margin-top: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.choose_plate{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text{
  font-size: 14px;
  color: #606266;
}
.template_addbutton{
  text-align: right;
  width: 80%;
}
.sewrw_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box{
  display: flex;
  align-items: center;
}
.content_box{
  /* width: 130px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
@media (max-width: 768px){
  .cell button{
    margin:1vw 0 !important;
  }
}
</style>
